<template>
    <div class="articleViewBox">
        <div class="single-img" v-if="data.imgValue">
            <img :src="dataList.uploadfiles" alt="">
        </div>
        <div class="page-detail-title">
            <div class="page-detail-title-wrap">
                <h3 style="width: 100%;">{{ dataList.title }}</h3>
                <div class="article-title">
                    <p class="attribute"><span class="mr-3">发布时间: {{ dataList.created_at }}</span><span v-if="data.browseValue">浏览量: {{ dataList.hits }}</span></p>
                    <div class="share"><i class="font-icon font-icon-fenx"></i><span class="share-text">分享</span></div>
                </div>
            </div>
        </div>
        <div class="page-detail-content">
            <div class="content_wrap" v-html="dataList.content"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'articleDeitelView',
  props: {
    data: Object
  },
  data () {
    return {
      activeName: '1',
      scace: '1',
      dataList: {
        id: 115,
        slug: '115',
        cid: 2,
        title: '批量出口中亚，环卫机械！',
        uploadfiles:
                    '//cdn.myxypt.com/3c4f22d1/24/09/f3e47cdfb5932820f26385bbef86faf523ad0c64.png',
        content:
                    '<p style="text-align: center;">这个七月，交车忙！</p><p style="text-align: center;">出海再上新<br></p><p style="text-align: center;">20余台压缩式垃圾车 </p><p style="text-align: center;">为共建“一带一路”再添动力</p><p style="text-align: center;"><img src="https://cdn.myxypt.com/3c4f22d1/24/09/f3e47cdfb5932820f26385bbef86faf523ad0c64.png"></p><p style="text-align: center;"><span style="text-wrap: nowrap;">7月10日</span></p><p style="text-align: center;"><span style="text-wrap: nowrap;">以“绿色驱动 智领未来”为主题的</span></p><p style="text-align: center;"><span style="text-wrap: nowrap;">环卫机械批量出口中亚</span></p><p style="text-align: center;"><span style="text-wrap: nowrap;">发车仪式隆重举行</span></p><p><br></p>',
        timeline: 1725495006,
        isgood: 0,
        flag: 1,
        istop: 0,
        hits: 7,
        orders: 1,
        ctitle: '',
        cdescription: '',
        level: 0,
        description: '',
        name: '批量出口中亚，环卫机械！',
        media: [
          {
            type: 'image',
            url:
                            '//cdn.myxypt.com/3c4f22d1/24/09/f3e47cdfb5932820f26385bbef86faf523ad0c64.png'
          }
        ],
        summary: '',
        created_at: '2024-09-05 08:10:06',
        cate: {
          cid: 2,
          slug: '2',
          cname: '环卫机械',
          word: null,
          parentid: 0,
          depth: 0,
          orders: 2,
          flag: 1,
          intro: '',
          timeline: 1665447957,
          elite: 0,
          img: '',
          linktype: 1,
          linkurl: '',
          target: 1,
          content: null,
          title: '',
          description: '',
          banner: '',
          id: 2,
          name: '环卫机械'
        }
      }
    }
  },

  methods: {},
  mounted () {
    console.log('初始数据1111', this.data)
  }
}
</script>

<style scoped>
/deep/ img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
}

.content_wrap {
    line-height: 1.6;
}

.page-detail-title-wrap {
    padding: 10px 15px;
}

.article-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.page-detail-title-wrap .attribute {
    font-size: 12px;
    color: #999;
}

.article-title .share {
    position: absolute;
    right: 0;
    width: 60px;
    height: 24px;
    background: #f5f5f5;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.article-title .share .share-text {
    font-size: 12px;
    color: #555;
    margin-right: 5px;
}

.content_wrap p img {
    max-width: 100%;
}

.mr-3 {
    margin-right: .75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/article/articleDeitelView.vue